import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

/**
 * i18n configuration for UNIVERS COSMETIC.
 *
 * - Backend: HTTP fetch — translations live in /public/locales/{lng}/{ns}.json,
 *   loaded lazily per namespace (only `common` + `nav` are preloaded).
 * - Detector: localStorage > navigator > htmlTag, with FR as the fallback.
 * - Supported languages: en, fr. FR is the default for first-time visitors in
 *   the French market.
 */
i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: 'fr',
        supportedLngs: ['fr', 'en'],
        ns: ['common', 'nav', 'portal'],
        defaultNS: 'common',
        load: 'languageOnly',
        backend: {
            loadPath: '/locales/{{lng}}/{{ns}}.json',
        },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'uc.lang',
        },
        interpolation: {
            escapeValue: false, // React already escapes
        },
        returnEmptyString: false,
    });

export default i18n;
